<app-modal *ngIf="!isSmallScreen"
           id="lesson-game"
           [scale]="true"
           [nopadding]="true"
           [canClose]="false"
           [additionalHeight]="80"
           (closed)="onClose()"
           #modal
           [answerState]="answerState">
  <app-modal-ad *ngIf="author && !withoutHeader && isShowFinishScreen">
    <app-teacher-booking-surface-block [teacher]="author"></app-teacher-booking-surface-block>
  </app-modal-ad>

  <app-modal-body>
    <ng-container *ngTemplateOutlet="gameFrame"></ng-container>
  </app-modal-body>
</app-modal>

<app-modal *ngIf="state.showAbuse"
           (closed)="state.showAbuse = false"
           [middle]="true"
           [complain]="true">
  <app-modal-body>
    <app-complaint-form [type]="'lesson'" (cancel)="state.showAbuse = false"></app-complaint-form>
  </app-modal-body>
</app-modal>

<!-- mobile -->
<app-mobile-modal *ngIf="isSmallScreen"
(closed)="onClose()"
[titleVisible]="false">
  <app-mobile-modal-body>
    <ng-container *ngTemplateOutlet="gameFrame"></ng-container>
  </app-mobile-modal-body>
</app-mobile-modal>

<ng-template #gameFrame>
  <ng-template [ngIf]="state.ready">
    <div class="game-content" [class.mobile]="isSmallScreen" [class.loaded]="!frameLoaded" *ngIf="safeGameUrl">
      <div class="loader-holder" *ngIf="!frameLoaded">
        <loading-game></loading-game>
      </div>
      <iframe [src]="safeGameUrl"
              width="100%" [attr.height]="frameHeight" sandbox="allow-same-origin allow-scripts allow-forms"
              allow="clipboard-read; clipboard-write; accelerometer; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen (scroll)="onScroll($event)"
              class="game" id="gameFrame">
      </iframe>
      <div class="additional-content" [class.hidden]="!gameIsFinished || !gameIsFinish">
        <app-pane [item]="lessonPane"></app-pane>
        <app-user-profile-classes-subpage [id]="author?.id"></app-user-profile-classes-subpage>
      </div>
    </div>
  </ng-template>
</ng-template>
